/* Progressive enhancement: the article, links and form work without JavaScript. */
(() => {
  if (window.pcBlogReadingInstalled) return;
  window.pcBlogReadingInstalled = true;
  const cleanups = new WeakMap();
  function wire(root = document) {
    root.querySelectorAll('[data-pc-article]').forEach(article => {
      if (cleanups.has(article)) return;
      const content = article.querySelector('.pc-article-content');
      if (!content) return;
      const controller = new AbortController();
      let frame = 0;
      cleanups.set(article, () => { controller.abort(); cancelAnimationFrame(frame); });
      // Some legacy bodies repeat the template title. Retain their anchor and
      // source text, but show the title only once in the reading experience.
      const title = article.querySelector('.article-template__title')?.textContent.trim().replace(/\s+/g, ' ').toLowerCase();
      content.querySelectorAll('h1').forEach(heading => {
        if (heading.textContent.trim().replace(/\s+/g, ' ').toLowerCase() === title) heading.hidden = true;
      });
      content.querySelectorAll('p').forEach(paragraph => {
        if (!paragraph.textContent.trim() && !paragraph.querySelector('img,video,iframe,audio,svg,canvas,input,button')) paragraph.hidden = true;
      });
      content.querySelectorAll('table').forEach((table, index) => {
        if (table.closest('.pc-table-scroll')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'pc-table-scroll';
        const columns = Math.max(0, ...[...table.rows].map(row => row.cells.length));
        if (columns > 3) wrapper.classList.add('pc-table-wide');
        else {
          wrapper.classList.add('pc-table-fit');
          if (columns === 3) wrapper.classList.add('pc-table-3');
          // Three columns with a header row stack into one card per row on phones (CSS, <=600px): squeezed into a
          // phone column they broke words mid-word. The first cell titles the card; the others carry their column name.
          const head = table.tHead?.rows[0] || (table.rows[0] && [...table.rows[0].cells].every(cell => cell.tagName === 'TH') ? table.rows[0] : null);
          if (columns === 3 && head && head.cells.length === 3) {
            wrapper.classList.add('pc-table-stack');
            if (!table.tHead) head.classList.add('pc-table-headrow');
            const labels = [...head.cells].map(cell => cell.textContent.trim());
            [...table.rows].forEach(row => {
              if (row === head) return;
              [...row.cells].forEach((cell, i) => { if (i > 0 && labels[i]) cell.dataset.label = labels[i]; });
            });
          }
        }
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', table.caption?.textContent.trim() || (columns > 3 ? `Article table ${index + 1}, scroll horizontally to see all columns` : `Article table ${index + 1}`));
        table.before(wrapper);
        wrapper.append(table);
      });
      content.querySelectorAll('pre').forEach(pre => { if (!pre.hasAttribute('tabindex')) pre.tabIndex = 0; });
      const headings = [...content.querySelectorAll('h2')].filter(h => h.textContent.trim() && !h.closest('details,blockquote,table'));
      if (headings.length < 3) return;
      const usedIds = new Set([...document.querySelectorAll('[id]')].map(e => e.id));
      headings.forEach((heading, index) => {
        if (heading.id) return;
        const base = 'section-' + (heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || (index + 1));
        let id = base, suffix = 2;
        while (usedIds.has(id)) id = `${base}-${suffix++}`;
        heading.id = id;
        usedIds.add(id);
      });
      article.querySelectorAll('[data-pc-contents-links]').forEach(container => {
        container.replaceChildren(...headings.map(heading => {
          const link = document.createElement('a');
          link.href = '#' + encodeURIComponent(heading.id);
          link.textContent = heading.textContent.trim();
          return link;
        }));
      });
      article.querySelectorAll('[data-pc-contents-desktop],[data-pc-contents-mobile]').forEach(e => { e.hidden = false; });
      const links = [...article.querySelectorAll('[data-pc-contents-links] a')];
      const update = () => {
        frame = 0;
        const current = [...headings].reverse().find(h => h.getBoundingClientRect().top <= 160) || headings[0];
        links.forEach(a => {
          if (decodeURIComponent(a.hash.slice(1)) === current.id) a.setAttribute('aria-current', 'location');
          else a.removeAttribute('aria-current');
        });
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      window.addEventListener('scroll', schedule, { passive: true, signal: controller.signal });
      window.addEventListener('resize', schedule, { passive: true, signal: controller.signal });
      update();
      // Newly generated heading links also work when opened directly in a new tab.
      if (location.hash) {
        let id;
        try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
        const target = headings.find(h => h.id === id);
        if (target) requestAnimationFrame(() => target.scrollIntoView());
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => wire(), { once: true });
  else wire();
  document.addEventListener('shopify:section:load', event => wire(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-pc-article]').forEach(article => { cleanups.get(article)?.(); cleanups.delete(article); });
  });
})();
